<ui-view></ui-view>
<ngx-ui-loader></ngx-ui-loader>
